import React from "react";

const Container = ({ children, className }) => {
  return (
    <div className={`max-w-7xl px-5 py-5 mx-auto ${className}`}>{children}</div>
  );
};

export default Container;
